<div class="row" class="product-list-item">
  <div class="d-flex flex-column flex-md-row">
    <div class="prod-details" (click)="goToPdp(product, $event)">
      <div class="image-wrapper">
        <cx-media
          class="cx-product-image"
          [container]="getImageRendition(product?.firstVariantImage)"
          format="string"
          [alt]="product?.baseProductName"
          [class.is-missing-fish]="businessType === 'fish'"
        ></cx-media>
      </div>
      <div class="details-wrapper">
        <div class="sku">
          <app-tooltip-text
            [ngClass]="['sku-truncate', product?.code]"
            [tooltipContent]="product?.baseProduct"
            [content]="product?.baseProduct"
            placement="bottom"
          >
          </app-tooltip-text>
          <span class="in-stock" *ngIf="product?.inStockFlag === true" [class.ml-0]="isSkuTruncated()">
            <div>{{ 'product.inStock' | cxTranslate }}</div>
          </span>

          <ng-container *ngIf="product?.inStockFlag === false && product?.stockStatusDisplay; else noStock">
            <span class="in-stock" *ngIf="product?.stockStatusDisplay === 'inStock'" [class.ml-0]="isSkuTruncated()">
              <div>{{ 'product.inStock' | cxTranslate }}</div>
            </span>
            <span class="no-stock" *ngIf="product?.stockStatusDisplay === 'outOfStock'" [class.ml-0]="isSkuTruncated()">
              <div>{{ 'product.noStock' | cxTranslate }}</div>
            </span>
            <span
              class="discontinued"
              *ngIf="product?.stockStatusDisplay === 'discontinued'"
              [class.ml-0]="isSkuTruncated()"
            >
              <div>{{ 'product.discontinued' | cxTranslate }}</div>
            </span>
          </ng-container>

          <ng-template #noStock>
            <span class="no-stock" *ngIf="product?.inStockFlag === false" [class.ml-0]="isSkuTruncated()">
              <div>{{ 'product.noStock' | cxTranslate }}</div>
            </span>
          </ng-template>
        </div>
        <!-- <div [ngClass]="['prod-name', product?.code]" [innerHTML]="product?.baseProductName"></div> -->
        <app-tooltip-text
          [ngClass]="[
            'prod-name',
            product?.code,
            'prod-name-PLP',
            'prod-name-PLP-custom-styling',
            activeCountry$ | async
          ]"
          [class.prod-name-list]="isPlpPopupEnabled"
          [tooltipContent]="product?.baseProductName"
          [content]="product?.baseProductName"
          placement="bottom"
        >
        </app-tooltip-text>
        <div
          class="color-variant"
          [class.mt-longer]="isColorVariantMarginTopLonger$ | async"
          [class.mt-lg-auto]="isColorVariantMarginTopAuto$ | async"
        >
          <cx-media
            class="cx-product-image"
            *ngIf="product?.firstVariantColor"
            [container]="getColorImageRendition(product?.firstVariantColor, product?.baseProduct)"
            [class.is-missing-fish]="businessType === 'fish'"
          ></cx-media>
          <ng-container *ngFor="let image of product?.variantOptions | slice : 0 : 4">
            <ng-container *ngFor="let img of image?.variantOptionQualifiers">
              <ng-container *ngIf="img?.qualifier === 'color' && product?.firstVariantColor?.url !== img?.image?.url">
                <cx-media
                  class="cx-product-image"
                  [container]="getColorImageRendition(img?.value, product?.baseProduct)"
                  [class.is-missing-fish]="businessType === 'fish'"
                ></cx-media>
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="product?.hasVariants && !isPlpPopupEnabled">
            <div
              class="available-multivariant"
              *ngIf="!product?.firstVariantColor && !hasProdColor(product?.baseProduct)"
            >
              {{ 'product.noColorVariants' | cxTranslate }}
            </div>
          </ng-container>
        </div>
        <app-promotional-text
          *ngIf="product?.potentialPromotions && !showSrp; else showDealerPricePromoView1"
          class="d-sm-none d-md-block d-lg-block d-xl-none mt-auto"
          [product]="product"
          [promotionLocation]="'PLP'"
        ></app-promotional-text>
        <ng-template #showDealerPricePromoView1>
          <app-promotional-text
            *ngIf="dealerPrices && !showSrp"
            class="d-sm-none d-md-block d-lg-block d-xl-none mt-auto"
            [dealerPriceData]="dealerPriceData(product?.code)"
            [promotionLocation]="'PLP'"
          ></app-promotional-text>
        </ng-template>
        <!-- TABLET MODE ONLY-->
        <div
          class="replacement-tablet-only replacement-of"
          *ngIf="product?.replacementOf"
          [style.min-height.px]="replacementHeightOnTablet$ | async"
          [style.max-height.px]="replacementHeightOnTablet$ | async"
          [class.mt-auto]="
            product?.replacementOf &&
            product?.replacedBy &&
            !showSrp &&
            ((showGstExclusive$ | async) && showGstInclusive$ | async)
          "
        >
          <div [ngClass]="['replacement-of', product?.code]">
            <div class="label">{{ 'product.productList.replacementOf' | cxTranslate }}</div>
            <div class="value">
              <a
                tabindex="0"
                class="pdp-link"
                [routerLink]="{ cxRoute: 'product', params: product.replacementOf } | cxUrl"
                (click)="replacement($event, product.replacementOf)"
              >
                <app-tooltip-text
                  class="prod-name-grid-list"
                  [tooltipContent]="product?.replacementOf?.name"
                  [content]="product?.replacementOf?.name"
                  placement="bottom"
                >
                </app-tooltip-text>
              </a>
            </div>
          </div>
          <div class="replaced-by" *ngIf="!product?.replacementOf && product?.replacedBy">
            <div class="label">{{ 'product.productList.replacedBy' | cxTranslate }}</div>
            <div class="value">
              <a
                tabindex="0"
                class="pdp-link"
                [routerLink]="{ cxRoute: 'product', params: product.replacedBy } | cxUrl"
                (click)="replacement($event, product.replacedBy)"
              >
                <app-tooltip-text
                  class="prod-name-grid-list"
                  [tooltipContent]="product?.replacedBy?.name"
                  [content]="product?.replacedBy?.name"
                  placement="bottom"
                >
                </app-tooltip-text>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="prod-prices" (click)="goToPdp(product, $event)">
      <div class="prod-prices-wrapper">
        <div
          class="srp-base-wrapper promotion-text-cls"
          [class.mh-60]="(product?.srpPrice?.formattedValue && showGstInclusive$ | async) || isSrpWrapped()"
        >
          <div [ngClass]="['srp-wrapper', product?.code]">
            <div class="label">{{ 'product.productList.srp' | cxTranslate }}</div>
            <div class="value" *ngIf="product?.variantOptions && product?.srpPrice?.formattedValue; else srp">
              {{ 'product.productList.from' | cxTranslate }}
              <span class="text-nowrap"
                >{{ product?.srpPrice?.formattedValue
                }}<span *ngIf="product?.srpPrice?.formattedValue && showGstInclusive$ | async" class="gst-label">{{
                  'gst.inclusive' | cxTranslate
                }}</span></span
              >
            </div>
            <ng-template #srp>
              <div class="value">
                {{ product?.srpPrice?.formattedValue
                }}<span *ngIf="product?.srpPrice?.formattedValue && showGstInclusive$ | async" class="gst-label">{{
                  'gst.inclusive' | cxTranslate
                }}</span>
              </div>
            </ng-template>
          </div>
          <div class="base-wrapper" *ngIf="!showSrp && !basepriceHidden">
            <div class="label">{{ 'product.productList.basePrice' | cxTranslate }}</div>
            <div class="value" *ngIf="product?.variantOptions && product?.basePrice?.formattedValue; else baseprice">
              {{ 'product.productList.from' | cxTranslate }}
              <span class="text-nowrap"
                >{{ product?.basePrice?.formattedValue
                }}<span *ngIf="product?.basePrice?.formattedValue && showGstExclusive$ | async" class="gst-label">{{
                  'gst.exclusive' | cxTranslate
                }}</span></span
              >
            </div>
            <ng-template #baseprice>
              <div class="value">
                {{ product?.basePrice?.formattedValue
                }}<span *ngIf="product?.basePrice?.formattedValue && showGstExclusive$ | async" class="gst-label">{{
                  'gst.exclusive' | cxTranslate
                }}</span>
              </div>
            </ng-template>
          </div>
        </div>
        <div class="dealer-replacement-wrapper">
          <div
            class="dealer-wrapper"
            *ngIf="!showSrp"
            [style.width.px]="dealerPriceWidthOnDesktop$ | async"
            [class.mt-12]="product?.srpPrice?.formattedValue && showGstInclusive$ | async"
          >
            <div class="label">{{ 'product.productList.dealerPrice' | cxTranslate }}</div>
            <div
              class="value"
              [class.erpPromo]="
                dealerPriceData(product?.code)?.promotionMessage &&
                dealerPriceData(product?.code)?.promotionMessage !== ''
              "
              *ngIf="product?.variantOptions && dealerPrice(product?.code); else dealerprice"
            >
              <div class="value"></div>
              <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(product?.code); else dealerPriceReady">
                <div class="spinner-shimano" *ngIf="hasDealerPriceSubs">
                  <div></div>
                </div>
                <div class="no-dealer-price no-dealer-price-pli" *ngIf="!hasDealerPriceSubs"></div>
              </div>
              <div class="value"></div>
              <ng-template #dealerPriceReady>
                {{ 'product.productList.from' | cxTranslate }}
                <span class="text-nowrap">{{ dealerPrice(product?.code) }}</span>
                <span *ngIf="dealerPrice(product?.code) && showGstExclusive$ | async" class="gst-label">{{
                  'gst.exclusive' | cxTranslate
                }}</span>
                <app-erp-promotional-text
                  *ngIf="dealerPrices && !showSrp"
                  class="d-xl-block mt-auto"
                  [dealerPriceData]="dealerPriceData(product?.code)"
                ></app-erp-promotional-text>
              </ng-template>
            </div>
            <ng-template #dealerprice>
              <div
                class="value"
                [class.erpPromo]="
                  dealerPriceData(product?.code)?.promotionMessage &&
                  dealerPriceData(product?.code)?.promotionMessage !== ''
                "
              >
                <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(product?.code); else dealerPriceReady">
                  <ng-container *ngIf="tooltipIconConfig$ | async as tooltipIconConfig">
                    <div class="spinner-shimano spinner-shimano-pli" *ngIf="hasDealerPriceSubs">
                      <div></div>
                    </div>
                    <div
                      class="no-dealer-price no-dealer-price-pli"
                      *ngIf="!hasDealerPriceSubs && !tooltipIconConfig?.enabled; else noDealerPriceTooltip"
                    ></div>
                    <ng-template #noDealerPriceTooltip>
                      <app-tooltip-icon
                        *ngIf="!hasDealerPrice && tooltipIconConfig?.enabled && !hasDealerPriceSubs"
                        [noDealerPriceIcon]="tooltipIconConfig?.noDealerPriceIcon"
                        dealerPriceIconContainerClass="no-dealer-price-pli"
                        [uniqueClass]="product?.code"
                        placement="bottom-right"
                        [tooltipContent]="'tooltip.hasNoDealerPrice' | cxTranslate"
                        [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
                        [noPointerEventsOnElement]="tooltipIconConfig?.noPointerEventsOnElement"
                        [handleEvents]="tooltipIconConfig?.handleEvents"
                      ></app-tooltip-icon>
                    </ng-template>
                  </ng-container>
                </div>
                <ng-template #dealerPriceReady>
                  {{ dealerPrice(product?.code) }}
                  <span *ngIf="dealerPrice(product?.code) && showGstExclusive$ | async" class="gst-label">{{
                    'gst.exclusive' | cxTranslate
                  }}</span>
                  <app-erp-promotional-text
                    *ngIf="dealerPrices && !showSrp"
                    class="d-xl-block mt-auto"
                    [dealerPriceData]="dealerPriceData(product?.code)"
                  ></app-erp-promotional-text>
                </ng-template>
              </div>
            </ng-template>
          </div>
          <app-promotional-text
            *ngIf="product?.potentialPromotions && !showSrp; else showDealerPricePromoView3"
            class="d-sm-block d-md-none mt-auto"
            [product]="product"
            [promotionLocation]="'PLP'"
          ></app-promotional-text>
          <ng-template #showDealerPricePromoView3>
            <app-promotional-text
              *ngIf="dealerPrices && !showSrp"
              class="d-sm-block d-md-none mt-auto"
              [dealerPriceData]="dealerPriceData(product?.code)"
              [promotionLocation]="'PLP'"
            ></app-promotional-text>
          </ng-template>
          <div class="replacement-wrapper" [class.ofBy-present]="product?.replacementOf && product?.replacedBy">
            <div class="replacement-of" *ngIf="product?.replacementOf">
              <div class="label">{{ 'product.productList.replacementOf' | cxTranslate }}</div>
              <div class="value">
                <a
                  tabindex="0"
                  class="pdp-link"
                  [routerLink]="{ cxRoute: 'product', params: product.replacementOf } | cxUrl"
                  (click)="replacement($event, product.replacementOf)"
                >
                  <app-tooltip-text
                    class="prod-name-grid-list"
                    [tooltipContent]="product?.replacementOf?.name"
                    [content]="product?.replacementOf?.name"
                    placement="bottom"
                  >
                  </app-tooltip-text>
                </a>
              </div>
            </div>
            <div class="replaced-by" *ngIf="product?.replacedBy">
              <div class="label">{{ 'product.productList.replacedBy' | cxTranslate }}</div>
              <div class="value">
                <a
                  tabindex="0"
                  class="pdp-link"
                  [routerLink]="{ cxRoute: 'product', params: product.replacedBy } | cxUrl"
                  (click)="replacement($event, product.replacedBy)"
                >
                  <app-tooltip-text
                    class="prod-name-grid-list"
                    [tooltipContent]="product?.replacedBy?.name"
                    [content]="product?.replacedBy?.name"
                    placement="bottom"
                  >
                  </app-tooltip-text>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-promotional-text
        *ngIf="product?.potentialPromotions && !showSrp; else showDealerPricePromoView2"
        class="d-sm-none d-xl-block mt-auto test1"
        [product]="product"
        [promotionLocation]="'PLP'"
      ></app-promotional-text>
      <ng-template #showDealerPricePromoView2>
        <app-promotional-text
          *ngIf="dealerPrices && !showSrp"
          class="d-sm-none d-xl-block mt-auto test2"
          [dealerPriceData]="dealerPriceData(product?.code)"
          [promotionLocation]="'PLP'"
        ></app-promotional-text>
      </ng-template>

      <!-- TABLET MODE ONLY-->
      <div
        class="replacement-tablet-only replaced-by"
        [class.mt-auto]="
          (product?.replacementOf && product?.replacedBy && showSrp) ||
          (!showSrp && !(showGstExclusive$ | async) && !(showGstInclusive$ | async) && !isPlpPopupEnabled)
        "
      >
        <div [ngClass]="['replaced-by', product?.code]" *ngIf="product?.replacedBy">
          <div class="label">{{ 'product.productList.replacedBy' | cxTranslate }}</div>
          <div class="value">
            <a
              tabindex="0"
              class="pdp-link"
              [routerLink]="{ cxRoute: 'product', params: product.replacedBy } | cxUrl"
              (click)="replacement($event, product.replacedBy)"
            >
              {{ product?.replacedBy?.name }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="cta-wrapper" *ngIf="!isPlpPopupEnabled; else newPlpButtons">
    <div class="pdp-link">
      <a
        tabindex="0"
        [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
        (click)="gtmProductClick(product, position)"
      >
        <mat-icon
          class="material-icons-sharp light"
          matTooltip="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
          [matTooltipPosition]="'below'"
          matTooltipClass="icon-tooltip"
          aria-label="displays a tooltip in bottom"
          [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
          >assignment</mat-icon
        >
      </a>
    </div>
    <div class="order-form" *ngIf="product?.showOrderFormButton">
      <a
        tabindex="0"
        [routerLink]="
          { cxRoute: 'orderForm', params: { code: product?.baseProduct, name: escape(product?.baseProductName) } }
            | cxUrl
        "
      >
        <mat-icon
          matTooltip="{{ 'buttonTooltip.plp.orderFormButton' | cxTranslate }}"
          [matTooltipPosition]="'below'"
          matTooltipClass="icon-tooltip"
          aria-label="displays a tooltip in bottom"
          class="material-icons-sharp light"
          [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
          >note_add</mat-icon
        >
      </a>
    </div>
  </div>

  <ng-template #newPlpButtons>
    <div class="plp-buttons">
      <div
        [ngClass]="isMobileSize && !product?.showOrderFormButton ? 'buttons-mobile-view' : ''"
        class="addtocart-orderform-button add-to-cart-button"
      >
        <div
          class="button-wrapper"
          matTooltip="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
          [matTooltipPosition]="'below'"
          [matTooltipClass]="'button-tooltip'"
          aria-label="displays a tooltip in bottom"
          [ngClass]="!product?.showOrderFormButton || isMobileSize ? 'remove-max-width' : ''"
        >
          <button
            [disabled]="!dealerPrice(product?.code)"
            class="btn btn-primary"
            type="button"
            (click)="plpGridModalScroll(product)"
          >
            <mat-icon svgIcon="add-to-cart"></mat-icon>
          </button>
        </div>
      </div>
      <div
        *ngIf="product?.showOrderFormButton"
        [ngClass]="isMobileSize && product?.showOrderFormButton ? 'buttons-mobile-view' : ''"
        class="addtocart-orderform-button order-form-mobile"
      >
        <div
          matTooltip="{{ 'buttonTooltip.plp.orderFormButton' | cxTranslate }}"
          [matTooltipPosition]="'below'"
          matTooltipClass="icon-tooltip"
          aria-label="displays a tooltip in bottom"
          [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
          class="order-form"
          [ngClass]="isMobileSize ? 'remove-max-width' : ''"
        >
          <a
            tabindex="0"
            [routerLink]="
              { cxRoute: 'orderForm', params: { code: product?.baseProduct, name: escape(product?.baseProductName) } }
                | cxUrl
            "
          >
            <mat-icon svgIcon="order-form-plp"></mat-icon>
          </a>
        </div>
      </div>
    </div>
  </ng-template>
</div>
